import React, {useMemo} from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'

import SectionLoader from '../SectionLoader'
import ItemsColumns from "../ItemsColumns"
import Badge from 'js/components/shared/Badge'

import styles from './ServicesAndEquipSection.module.scss'

const cx = classnames.bind(styles)

const SerAndEqItem = function ({
  data: {
    icon,
    label,
    paying,
    popupLink,
    anchorLink,
  }
}) {
  const WrappTag = popupLink?.dataAttr || anchorLink?.dataAttr ? 'a' : 'div';
  const wrapAttrs = {
    className: [popupLink?.dataAttr?.class, anchorLink?.dataAttr?.class].filter(Boolean),
    ...(popupLink?.dataAttr?.['amenity-code'] ? {['data-amenity-code']: popupLink?.dataAttr?.['amenity-code']} : {}),
    ...(popupLink?.dataAttr?.['hotel-id'] ? {['data-hotel-id']: popupLink?.dataAttr?.['hotel-id']} : {}),
    ...(popupLink?.dataAttr?.['amenity-code'] ? {href: '#' + popupLink?.dataAttr?.['amenity-code']} : {}),
    ...(anchorLink?.dataAttr?.['anchor-id'] ? {href: '#' + anchorLink?.dataAttr?.['anchor-id']} : {}),
  }

  return (
    <WrappTag
      {...wrapAttrs}
      className={cx('list-item-wrap', ...wrapAttrs.className)}
    >
      <span className={cx('list-item-icon')}><i className={icon} /></span>
      <span className={cx('list-item-text')}>{label}</span>
      {paying && (
        <Badge className={cx('list-item-paying')} color="gray" theme="semi-round">{paying}</Badge>
      )}
    </WrappTag>
  )
}

const ServicesAndEquipSection = function ({
  isLoading,
  data,
  info = {},
  className = ''
}) {
  const listObj = info?.nestedList?.items
  const itemsOrdered = listObj
    ? Object.keys(listObj)
      .map((id) => ({id, ...listObj[id]}))
      .sort((a, b) => b.order > a.order ? -1 : 1)
    : []

  return (
    <div className={cx('root', className)}>
      {isLoading ? <SectionLoader className={cx('root', 'loader-root')} /> : (
        <div className={cx('content')}>
          <ul className={cx('list')}>
            {info?.list?.items?.map((item, index) => (
              <li key={item?.icon} className={cx('list-item', item?.order >=0 && `order-${item.order}`)}>
                <SerAndEqItem data={item} />
              </li>
            ))}
          </ul>
          <div className={cx('columns')}>
            <ItemsColumns items={itemsOrdered} />
          </div>
        </div>
      )}
    </div>
  )
}

ServicesAndEquipSection.propTypes = {
  data: PropTypes.any,
  info: PropTypes.object,
  isLoading: PropTypes.bool,
  className: PropTypes.string
}

export default ServicesAndEquipSection
